import React from "react";
import styled from "styled-components";
import LineChart from "./LineChart";
const Wrapper = styled.div`
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  height: 100%;
  width: 100%;
  h5 span {
    margin-right: 4px;
  }
  .border-CK {
    border-bottom: 1px solid #e5e7eb;
  }
`;

const ChartCard = ({
  numbers,
  date,
  color,
  bgColor,
  pointColor,
  title,
  karaokeColor,
  karaokeBgColor,
  karaokePointColor,
  type = "music",
}) => {
  return (
    <Wrapper>
      <div className="flex flex-col p-4 md:p-6 h-full">
        <div className="flex flex-row justify-between border-CK pb-1">
          <h5 className="text-sm font-bold flex-1">Ерөнхий самбар</h5>
          <div className="flex flex-row gap-3">
            {/* {type === "music" ? (
              <h5 className="color-grey text-xs">
                <span style={{ color: "#F59E0B" }}>●</span>Дуу
              </h5>
            ) : (
              <h5 className="color-grey text-xs">
                <span style={{ color: "#0061FF" }}>●</span>Караоке
              </h5>
            )} */}
          </div>
        </div>
        <div className="flex-1 min-h-0 relative">
          <LineChart
            numbers={numbers}
            date={date}
            color={color}
            bgColor={bgColor}
            pointColor={pointColor}
            title={title}
            karaokeColor={karaokeColor}
            karaokeBgColor={karaokeBgColor}
            karaokePointColor={karaokePointColor}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default ChartCard;
